import { useEffect, useState } from 'react';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

const readMode = () =>
  typeof document === 'undefined'
    ? undefined
    : document.body.getAttribute('data-theme-mode');

/**
 * Switches to the other installed theme. App.tsx registers every theme with
 * the 'dark' variant so that 'make' stays the default, so the variant can't
 * tell light from dark; the mode the theme provider applies to <body> can.
 */
export const useThemeToggle = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const [mode, setMode] = useState(readMode);

  useEffect(() => {
    const observer = new MutationObserver(() => setMode(readMode()));
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-theme-mode'],
    });
    return () => observer.disconnect();
  }, []);

  const toggle = () => {
    const themes = appThemeApi.getInstalledThemes();
    const activeId = appThemeApi.getActiveThemeId() ?? themes[0]?.id;
    const next = themes.find(theme => theme.id !== activeId);
    if (next) appThemeApi.setActiveThemeId(next.id);
  };

  return { isDark: mode === 'dark', toggle };
};
